<div class="container" >
  <div>
   
    <ion-row>
      <ion-col size="3" class="form-col">
        <mat-form-field class="custom-mat-field mat-height40 mat-input-style">
          <mat-select placeholder="Select" [(ngModel)]="selectedYearForCompetency"
            (selectionChange)="getYearSetupForReimbursement(selectedYearForCompetency)">
            <mat-option [value]="item.year" *ngFor="let item of pmsYears">
              {{sharedService.transformYearToFyFormat(item.year)}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </ion-col>
    
    </ion-row>
    
    
    <ion-row class="card-row">
      <ion-col size-sm="6" size-md="4" size-lg="2.4" size-xs="6"   *ngIf="loggedInUserRole !== 'Employee'">
        <div class="lnd-card" (click)="onClickCard('1')">
          <div class="lnd-card-flex">
            <div class="icon-circle bg-orange">
              <span class="material-icons">how_to_vote</span>
            </div>
            <div class="lnd-card-text">
              <p class="lnd-fs-12 lnd-font-semibold">Nominations</p>
              <p class="lnd-fs-12 lnd-font-bold lnd-blue lnd-cursor">250</p>
            </div>
          </div>
        </div>
      </ion-col>
    
      <ion-col size-sm="6" size-md="4" size-lg="2.4" size-xs="6">
        <div class="lnd-card" (click)="onClickCard('2')">
          <div class="lnd-card-flex">
            <div class="icon-circle bg-green">
              <span class="material-icons">check_circle</span>
            </div>
            <div class="lnd-card-text">
              <p class="lnd-fs-12 lnd-font-semibold">Attended</p>
              <p class="lnd-fs-12 lnd-font-bold lnd-blue lnd-cursor">200</p>
            </div>
          </div>
        </div>
      </ion-col>
    
      <ion-col size-sm="6" size-md="4" size-lg="2.4" size-xs="6">
        <div class="lnd-card" (click)="onClickCard('3')">
          <div class="lnd-card-flex">
            <div class="icon-circle bg-purple">
              <span class="material-icons">event_available</span>
            </div>
            <div class="lnd-card-text">
              <p class="lnd-fs-12 lnd-font-semibold">Upcoming Programs</p>
              <p class="lnd-fs-12 lnd-font-bold lnd-blue lnd-cursor">6</p>
            </div>
          </div>
        </div>
      </ion-col>
    
      <ion-col size-sm="6" size-md="4" size-lg="2.4" size-xs="6">
        <div class="lnd-card" (click)="onClickCard('4')">
          <div class="lnd-card-flex">
            <div class="icon-circle bg-blue">
              <span class="material-icons">groups</span>
            </div>
            <div class="lnd-card-text">
              <p class="lnd-fs-12 lnd-font-semibold">Total Mandays</p>
              <p class="lnd-fs-12 lnd-font-bold lnd-blue lnd-cursor">10000</p>
            </div>
          </div>
        </div>
      </ion-col>
    
      <ion-col
        size-sm="6"
        size-md="4"
        size-lg="2.4"
        size-xs="6"
        *ngIf="loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin' || loggedInUserRole == 'HOD'">
        <div class="lnd-card" (click)="onClickCard('5')">
          <div class="lnd-card-flex">
            <div class="icon-circle bg-red">
              <span class="material-icons">recommend</span>
            </div>
            <div class="lnd-card-text">
              <p class="lnd-fs-12 lnd-font-semibold">Recommended Programs</p>
              <p class="lnd-fs-12 lnd-font-bold lnd-blue lnd-cursor">5</p>
            </div>
          </div>
        </div>
      </ion-col>
    </ion-row>
    
    
    <!-- ====================================== Graph code ==================================================================== -->
    

    <!-- =====================================================  L&D Programme Performance Graph ==========================================-->

    <div class="cardBox" style="margin-top: 20px;" >
      <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
     
         <ion-row class="justify-content-center">
           <ion-col size-sm="12" size-md="7" size-lg="7" size-xs="12">
             <h4 class="mt-20 ml-10 mb-10">L&D Programme Performance</h4>
           </ion-col>
 
           <ion-col size-sm="12" size-md="5" size-lg="5" size-xs="12" style="display: flex; justify-content: flex-end;">
             <div class="d-flex graph-icon" >
               <span (click)="switchApprovedByFinanceGraph('bar')">
                 <img *ngIf="isApprovedByFinanceIcon != 'bar'" src="././assets/icon/BarGraphIcon.svg" alt="" class="cp">
                 <img *ngIf="isApprovedByFinanceIcon == 'bar'" src="././assets/icon/BarGraphActive.svg" alt="">
               </span>
               <span (click)="switchApprovedByFinanceTable()">
                 <img *ngIf="!isApprovedByFinanceTable" src="././assets/icon/tableIcon.svg" alt="" class="cp">
                 <img *ngIf="isApprovedByFinanceTable" src="././assets/icon/TableIconActive.svg" alt="">
               </span>
               <span (click)="switchApprovedByFinanceGraph('line')">
                 <img *ngIf="isApprovedByFinanceIcon != 'line'" src="././assets/icon/lineChartIcon.svg" alt=""
                   class="cp">
                 <img *ngIf="isApprovedByFinanceIcon == 'line'" src="././assets/icon/activeLineChart.svg" alt="">
               </span>
               <span>
                 <img (click)="downloadChartAsPDF('Employee Wise Trends')" src="././assets/icon/downloadIcon.svg" alt=""
                   class="cp">
               </span>
             </div>
           </ion-col>
         </ion-row>
         <ion-row>
          
          <ion-col size="4"> 
            <mat-form-field class="w-100 mat-height40 mat-input-style">
              <mat-select placeholder="Select" [(ngModel)]="selectedYearForCompetency"
                (selectionChange)="getYearSetupForReimbursement(selectedYearForCompetency)">
                <mat-option [value]="item.year" *ngFor="let item of pmsYears">
                  {{sharedService.transformYearToFyFormat(item.year)}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </ion-col>
         <ion-col size="3">
        <ng-select class="w250 ml-10" placeholder="Select Programme"  [(ngModel)]="selectedGraphEmployee" [clearable]="false" (change)="selectedGraphEmployeeChange($event)">
           <ng-option [value]="item.userId"
                 *ngFor="let item of arrEmployeesReport">{{item.name}}</ng-option>
             </ng-select>
         </ion-col>  
         </ion-row>
         
     <ion-row >
       <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" style="display: flex; justify-content: center;align-items: center; padding: 20px 0 20px 0;" >
         <div [ngClass]="{'dispNone' : !isApprovedByFinanceTable}">
           <div class="dashboardGraphTable"  >
             <!-- <table id="table-employee-wise-trends-data">
               <thead> 
                 <tr class="custom-size" >
                   <th>year</th>
                   <th>Performance Score</th>
                   <th>Potential Score</th>
                 
                 </tr>
               </thead>
               <tbody>
                 <tr *ngFor="let data of arrEmployeeWiseTrendsbyYear">
                   <td>{{data.xAxisValueData}}</td>
                   <td>{{data.seriesValueOneData}}</td>
                   <td>{{data.seriesValueTwoData}}</td>
                  
                 </tr>
               </tbody>
             </table> -->
           </div>
         </div>
 
         <div *ngIf="!isApprovedByFinanceTable" [ngClass]="{'dispNone' : isApprovedByFinanceTable}"  id="bar-line-chart-nine-box"
           style="width: 450px; height: 400px;">
         </div>
       </ion-col>
     </ion-row>
 
     
     </ion-col>
     </div> 
    




          <!-- ======================================================= Department Wise Performance ======================================= -->
   
    
          <div class="cardBox" style="margin-top: 20px;" >
            <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12" >
               <ion-row class="justify-content-center">
                 <ion-col size-sm="12" size-md="7" size-lg="7" size-xs="12">
                   <h4 class="mt-20 ml-10 mb-10">Department Wise Performance</h4>
                 </ion-col>
       
                 <ion-col size-sm="12" size-md="5" size-lg="5" size-xs="12" style="display: flex; justify-content: flex-end;">
                   <div class="d-flex graph-icon">
                     <span (click)="switchApprovedByFinanceGraph('bar')">
                       <img *ngIf="isApprovedByFinanceIcon != 'bar'" src="././assets/icon/BarGraphIcon.svg" alt="" class="cp">
                       <img *ngIf="isApprovedByFinanceIcon == 'bar'" src="././assets/icon/BarGraphActive.svg" alt="">
                     </span>
                     <span (click)="switchApprovedByFinanceTable()">
                       <img *ngIf="!isApprovedByFinanceTable" src="././assets/icon/tableIcon.svg" alt="" class="cp">
                       <img *ngIf="isApprovedByFinanceTable" src="././assets/icon/TableIconActive.svg" alt="">
                     </span>
                     <span (click)="switchApprovedByFinanceGraph('line')">
                       <img *ngIf="isApprovedByFinanceIcon != 'line'" src="././assets/icon/lineChartIcon.svg" alt=""
                         class="cp">
                       <img *ngIf="isApprovedByFinanceIcon == 'line'" src="././assets/icon/activeLineChart.svg" alt="">
                     </span>
                     <span>
                       <img (click)="downloadChartAsPDF('Employee Wise Trends')" src="././assets/icon/downloadIcon.svg" alt=""
                         class="cp">
                     </span>
                   </div>
                 </ion-col>
               </ion-row>
               <ion-row>               
                <ion-col size="4"> 
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <mat-select placeholder="Select" [(ngModel)]="selectedYearForCompetency"
                      (selectionChange)="getYearSetupForReimbursement(selectedYearForCompetency)">
                      <mat-option [value]="item.year" *ngFor="let item of pmsYears">
                        {{sharedService.transformYearToFyFormat(item.year)}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </ion-col>
               <ion-col size="3">
              <ng-select class="w250 ml-10" placeholder="Select Programme"  [(ngModel)]="selectedGraphEmployee" [clearable]="false" (change)="selectedGraphEmployeeChange($event)">
                 <ng-option [value]="item.userId"
                       *ngFor="let item of arrEmployeesReport">{{item.name}}</ng-option>
                   </ng-select>
               </ion-col>  
               <ion-col size="3">
                <ng-select class="w250 ml-10" placeholder="Select Department"  [(ngModel)]="selectedGraphEmployee" [clearable]="false" (change)="selectedGraphEmployeeChange($event)">
                   <ng-option [value]="item.userId"
                         *ngFor="let item of arrEmployeesReport">{{item.name}}</ng-option>
                     </ng-select>
                 </ion-col> 
               <!-- <ion-col size="4" >
                <ng-multiselect-dropdown class="w-100 mat mat-height40 mat-input-style"
                [placeholder]="'Select Department'"
                [settings]="dropdownSettings"
                [data]="getDepartmentsList"      
                formControlName="department"
                (onSelect)="onDepartmentSelect()"
                (onDeSelect)="onDepartmentDeSelect()"
                (onSelectAll)="onDepartmentAllSelect()"
                (onDeSelectAll)="onDepartmentAllDeSelect()">
              </ng-multiselect-dropdown>
              </ion-col> -->
               </ion-row>
               
           <ion-row >
             <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" style="display: flex; justify-content: center;align-items: center; padding: 20px 0 20px 0;" >
               <div [ngClass]="{'dispNone' : !isApprovedByFinanceTable}">
                 <div class="dashboardGraphTable"  >
                   <!-- <table id="table-employee-wise-trends-data">
                     <thead> 
                       <tr class="custom-size" >
                         <th>year</th>
                         <th>Performance Score</th>
                         <th>Potential Score</th>
                       
                       </tr>
                     </thead>
                     <tbody>
                       <tr *ngFor="let data of arrEmployeeWiseTrendsbyYear">
                         <td>{{data.xAxisValueData}}</td>
                         <td>{{data.seriesValueOneData}}</td>
                         <td>{{data.seriesValueTwoData}}</td>
                        
                       </tr>
                     </tbody>
                   </table> -->
                 </div>
               </div>
       
               <div *ngIf="!isApprovedByFinanceTable" [ngClass]="{'dispNone' : isApprovedByFinanceTable}"  id="bar-line-chart-nine-box"
                 style="width: 450px; height: 400px;">
               </div>
             </ion-col>
           </ion-row>
       
            
           </ion-col>
           </div> 



           <!-- =============================================== Employee Wise Performance ==================================== -->
           
           
    <div class="cardBox" style="margin-top: 20px;" >
      <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
         <ion-row class="justify-content-center">
           <ion-col size-sm="12" size-md="7" size-lg="7" size-xs="12">
             <h4 class="mt-20 ml-10 mb-10">Employee Wise Performance </h4>
           </ion-col>
 
           <ion-col size-sm="12" size-md="5" size-lg="5" size-xs="12" style="display: flex; justify-content: flex-end;" >
             <div class="d-flex graph-icon">
               <span (click)="switchApprovedByFinanceGraph('bar')">
                 <img *ngIf="isApprovedByFinanceIcon != 'bar'" src="././assets/icon/BarGraphIcon.svg" alt="" class="cp">
                 <img *ngIf="isApprovedByFinanceIcon == 'bar'" src="././assets/icon/BarGraphActive.svg" alt="">
               </span>
               <span (click)="switchApprovedByFinanceTable()">
                 <img *ngIf="!isApprovedByFinanceTable" src="././assets/icon/tableIcon.svg" alt="" class="cp">
                 <img *ngIf="isApprovedByFinanceTable" src="././assets/icon/TableIconActive.svg" alt="">
               </span>
               <span (click)="switchApprovedByFinanceGraph('line')">
                 <img *ngIf="isApprovedByFinanceIcon != 'line'" src="././assets/icon/lineChartIcon.svg" alt=""
                   class="cp">
                 <img *ngIf="isApprovedByFinanceIcon == 'line'" src="././assets/icon/activeLineChart.svg" alt="">
               </span>
               <span>
                 <img (click)="downloadChartAsPDF('Employee Wise Trends')" src="././assets/icon/downloadIcon.svg" alt=""
                   class="cp">
               </span>
             </div>
           </ion-col>
         </ion-row>
         <ion-row>
          
          <ion-col size="4"> 
            <mat-form-field class="w-100 mat-height40 mat-input-style">
              <mat-select placeholder="Select" [(ngModel)]="selectedYearForCompetency"
                (selectionChange)="getYearSetupForReimbursement(selectedYearForCompetency)">
                <mat-option [value]="item.year" *ngFor="let item of pmsYears">
                  {{sharedService.transformYearToFyFormat(item.year)}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </ion-col>
         <ion-col size="3">
        <ng-select class="w250 ml-10" placeholder="Select Programme"  [(ngModel)]="selectedGraphEmployee" [clearable]="false" (change)="selectedGraphEmployeeChange($event)">
           <ng-option [value]="item.userId"
                 *ngFor="let item of arrEmployeesReport">{{item.name}}</ng-option>
             </ng-select>
         </ion-col>  
         <ion-col size="3">
          <ng-select class="w250 ml-10" placeholder="Select Employee"  [(ngModel)]="selectedGraphEmployee" [clearable]="false" (change)="selectedGraphEmployeeChange($event)">
             <ng-option [value]="item.userId"
                   *ngFor="let item of arrEmployeesReport">{{item.name}}</ng-option>
               </ng-select>
           </ion-col>  
         <!-- <ion-col size="4">
          <ng-multiselect-dropdown 
            class="w-100 mat mat-height40 mat-input-style"
            [placeholder]="'Select Employee'"
            [settings]="dropdownSettings"
            [data]="getEmployeeList"      
            formControlName="department"
            (onSelect)="onEmployeeSelect()"
            (onDeSelect)="onEmployeeDeSelect()"
            (onSelectAll)="onEmployeeAllSelect()"
            (onDeSelectAll)="onEmployeeAllDeSelect()">
          </ng-multiselect-dropdown>
        </ion-col> -->

         </ion-row>
         
     <ion-row >
       <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" style="display: flex; justify-content: center;align-items: center; padding: 20px 0 20px 0;" >
         <div [ngClass]="{'dispNone' : !isApprovedByFinanceTable}">
           <div class="dashboardGraphTable"  >
             <!-- <table id="table-employee-wise-trends-data">
               <thead> 
                 <tr class="custom-size" >
                   <th>year</th>
                   <th>Performance Score</th>
                   <th>Potential Score</th>
                 
                 </tr>
               </thead>
               <tbody>
                 <tr *ngFor="let data of arrEmployeeWiseTrendsbyYear">
                   <td>{{data.xAxisValueData}}</td>
                   <td>{{data.seriesValueOneData}}</td>
                   <td>{{data.seriesValueTwoData}}</td>
                  
                 </tr>
               </tbody>
             </table> -->
           </div>
         </div>
 
         <div *ngIf="!isApprovedByFinanceTable" [ngClass]="{'dispNone' : isApprovedByFinanceTable}"  id="bar-line-chart-nine-box"
           style="width: 450px; height: 400px;">
         </div>
       </ion-col>
     </ion-row>
 
       
     </ion-col>
     </div> 
  </div>
</div>



